import { getUTCHtmlId } from 'common/util/time';
import React, { useEffect, useRef, useState } from 'react';
import { CLOSE_DROPDOWN_EVENT_NAME } from '../util/constants';
const Dropdown = ({ children, toggleClass, toggleChildren, contentClass, fullHeight = false, idPrefix = 'dropdown-', closeOnOutsideClick = true }) => {
    const [relativeTopPosition, setRelativeTopPosition] = useState(0);
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    /**
     * use ref for open state since the function gets called in the
     * pre-built functions attached to the native DOM listeners
     */
    const openStateRef = useRef(open);
    const contentId = idPrefix + getUTCHtmlId();
    const buttonId = idPrefix + 'button-' + getUTCHtmlId();
    function handleToggle() {
        setOpen(!openStateRef.current);
        openStateRef.current = !openStateRef.current;
    }
    useEffect(() => {
        if (open && fullHeight) {
            document.documentElement.classList.add('full-dropdown-open');
            setRelativeTopPosition(dropdownRef.current?.getBoundingClientRect().top ?? 0);
        }
        else {
            document.documentElement.classList.remove('full-dropdown-open');
        }
        return () => {
            document.documentElement.classList.remove('full-dropdown-open');
        };
    }, [open]);
    useEffect(() => {
        if (closeOnOutsideClick) {
            document.addEventListener('click', handleOutsideClick);
            dropdownRef.current?.addEventListener(CLOSE_DROPDOWN_EVENT_NAME, handleCloseDropdownEvent);
        }
        return () => {
            if (closeOnOutsideClick) {
                document.removeEventListener('click', handleOutsideClick);
                dropdownRef.current?.removeEventListener(CLOSE_DROPDOWN_EVENT_NAME, handleCloseDropdownEvent);
            }
        };
    }, []);
    /**
     * Closes the dropdown on outside click
     */
    function handleOutsideClick(event) {
        if (!dropdownRef.current || !buttonRef.current) {
            return;
        }
        const clickEventPath = event.composedPath();
        if (!clickEventPath.includes(dropdownRef.current) &&
            !clickEventPath.includes(buttonRef.current) &&
            openStateRef.current) {
            handleToggle();
        }
    }
    /**
     * Closes the dropdown on custom event 'closeDropdown'
     */
    function handleCloseDropdownEvent() {
        if (openStateRef.current) {
            handleToggle();
        }
    }
    return (React.createElement("div", { className: 'viewport-map__dropdown' + (fullHeight ? ' full-height' : '') + (open ? ' open' : '') },
        React.createElement("button", { ref: buttonRef, id: buttonId, className: 'viewport-map__dropdown__dropdown-btn' + (toggleClass ? ' ' + toggleClass : ''), "aria-expanded": open, "aria-controls": contentId, onClick: handleToggle }, toggleChildren),
        React.createElement("div", { ref: dropdownRef, id: contentId, style: { '--relative-top-position': relativeTopPosition + 'px' }, className: 'viewport-map__dropdown__dropdown-content' + (contentClass ? ' ' + contentClass : ''), "aria-labelledby": buttonId }, children)));
};
export default Dropdown;
